import React, { useState } from "react";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import { SiGumroad } from "react-icons/si";

const ComponentTixme = (props) => {
  const { fichierEtapes, pageConsultee } = props;

  const traduction = {
    back: "Précédent",
    close: "Fermer",
    last: "Terminer",
    next: "Suivant",
    open: "Ouvrir l'aide",
    skip: "Passer",
  };

  let stepsLoaded = [];
  let fileExist = false;

  // lorsque l'on clique sur une checkbox de condition rencontrée dans le fichier Json tixme, on rajoute ce tag à la liste des étapes validée ou au contraire on la retire
  const handleCheckbox = (event) => {
    let conditionsChecked = JSON.parse(
      localStorage.getItem("etapeTixmeCondition_" + fichierEtapes + "_" + pageConsultee)
    );

    if (!conditionsChecked) {
      conditionsChecked = [];
    }

    if (event.target.checked) {
      conditionsChecked.push(event.target.dataset.identifiant);
    } else {
      conditionsChecked = conditionsChecked.filter(
        (item) => item !== event.target.dataset.identifiant
      );
    }

    localStorage.setItem(
      "etapeTixmeCondition_" + fichierEtapes + "_" + pageConsultee,
      JSON.stringify(conditionsChecked)
    );
  };

  //  on charge le bon fichier tixme + etapes validées en fonction de l'instance ou l'on se trouve
  try {
    stepsLoaded = require("/public/tixme/" +
      fichierEtapes +
      "/" +
      fichierEtapes +
      "_" +
      pageConsultee +
      ".json");

    let localStorageCheckboxValide = JSON.parse(
      localStorage.getItem("etapeTixmeCondition_" + fichierEtapes + "_" + pageConsultee)
    );
    if (!localStorageCheckboxValide) localStorageCheckboxValide = [];

    stepsLoaded.forEach((element, index) => {
      if (index === 0) element.disableBeacon = true;
      element.placement = "top";
      element.locale = traduction;
      element.content = (
        <div className="tixme">
          <div dangerouslySetInnerHTML={{ __html: element.contentTixme }}></div>
          {element.conditionne &&
            element.conditionne.map((condition, index) => (
              <div key={index} className="ms-3 mt-1">
                <input
                  type="checkbox"
                  className="me-2"
                  data-identifiant={condition.identifiant}
                  defaultChecked={
                    localStorageCheckboxValide.includes(condition.identifiant) ? true : false
                  }
                  onClick={handleCheckbox}
                />
                {condition.label}
              </div>
            ))}
        </div>
      );
    });
    fileExist = true;
  } catch {
    fileExist = false;
  }

  const [joyride, setJoyride] = useState({});

  const { run, stepIndex, steps } = joyride;

  const handleJoyrideCallback = (data) => {
    const { action, index, status, type } = data;

    /* on traite une éventuelle action spéciale à réaliser à ce moment là (ouverture de la popup ou appui sur precedent ou suivant = déclaré dans le fichier JSON) */
    if (action === "update" && status === "running" && type === "tooltip") {
      if (stepsLoaded[index] && stepsLoaded[index].actionSpecialeOverflow) {
        console.log("depliage");
        let overflowID = stepsLoaded[index].actionSpecialeOverflow;
        const overflowBloc = document.getElementById(overflowID);
        overflowBloc.classList.remove("overflowContent");
        overflowBloc.classList.add("disableOverflowContent");
        document
          .getElementById("buttonDisableOverflowContent" + overflowID)
          .classList.add("d-none");
        document.getElementById("buttonOverflowContent" + overflowID).classList.remove("d-none");
      }
    }

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      if (action === "close") {
        setJoyride({ ...joyride, run: false });
      } else {
        setJoyride({ ...joyride, stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });

        let indexEnCours = index + (action === ACTIONS.PREV ? -1 : 1);

        localStorage.setItem(
          "etapeTixme_" + fichierEtapes + "_" + pageConsultee,
          JSON.stringify({ stepIndex: indexEnCours })
        );
      }
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setJoyride({ ...joyride, run: false, stepIndex: 0 });
    }
  };

  const handleClickStart = (e) => {
    let etapeEnCours = JSON.parse(
      localStorage.getItem("etapeTixme_" + fichierEtapes + "_" + pageConsultee)
    );
    if (etapeEnCours) {
      etapeEnCours = etapeEnCours.stepIndex;
    } else {
      etapeEnCours = 0;
    }

    setJoyride({ ...joyride, run: !run, steps: stepsLoaded, stepIndex: etapeEnCours });
  };

  return (
    <>
      {fileExist && (
        <>
          <div
            className="containerTixme persoBackColor "
            role="button"
            onClick={handleClickStart}
            id="boutonAide"
          >
            <SiGumroad size="1.5em" />
          </div>

          <Joyride
            callback={handleJoyrideCallback}
            continuous
            run={run}
            steps={steps}
            scrollToFirstStep
            showProgress
            showSkipButton
            spotlightClicks
            stepIndex={stepIndex}
            styles={{
              options: {
                width: 720,
              },
              tooltipContainer: {
                textAlign: "left",
              },
            }}
          />
        </>
      )}
    </>
  );
};

export default ComponentTixme;
